var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3335 3.66683C3.96531 3.66683 3.66683 3.96531 3.66683 4.3335V13.6668C3.66683 14.035 3.96531 14.3335 4.3335 14.3335H13.6668C14.035 14.3335 14.3335 14.035 14.3335 13.6668V4.3335C14.3335 3.96531 14.035 3.66683 13.6668 3.66683H4.3335ZM2.3335 4.3335C2.3335 3.22893 3.22893 2.3335 4.3335 2.3335H13.6668C14.7714 2.3335 15.6668 3.22893 15.6668 4.3335V13.6668C15.6668 14.7714 14.7714 15.6668 13.6668 15.6668H4.3335C3.22893 15.6668 2.3335 14.7714 2.3335 13.6668V4.3335Z",
    fill: "#293C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 6.33333C6.48257 6.33333 6.33333 6.48257 6.33333 6.66667C6.33333 6.85076 6.48257 7 6.66667 7C6.85076 7 7 6.85076 7 6.66667C7 6.48257 6.85076 6.33333 6.66667 6.33333ZM5 6.66667C5 5.74619 5.74619 5 6.66667 5C7.58714 5 8.33333 5.74619 8.33333 6.66667C8.33333 7.58714 7.58714 8.33333 6.66667 8.33333C5.74619 8.33333 5 7.58714 5 6.66667Z",
    fill: "#293C62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1951 7.19526C11.4554 6.93491 11.8776 6.93491 12.1379 7.19526L15.4712 10.5286C15.7316 10.7889 15.7316 11.2111 15.4712 11.4714C15.2109 11.7318 14.7888 11.7318 14.5284 11.4714L11.6665 8.60948L4.80458 15.4714C4.54423 15.7318 4.12212 15.7318 3.86177 15.4714C3.60142 15.2111 3.60142 14.7889 3.86177 14.5286L11.1951 7.19526Z",
    fill: "#293C62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUnknown);
export default __webpack_public_path__ + "static/media/image-unknown.62cb4721253a183ddd35321f0c77cfd1.svg";
export { ForwardRef as ReactComponent };